import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL;

export async function getAllEvents() {


    return axios({
        method: 'get',
        url: url + "/events"
        //url: "http://localhost:8000/api/events"
    }).then(res => {

        return res.data;
    });


}
export async function getSingleEvent(eventID) {
    return axios({
        method: 'get',
        url: url + "/events?id=" + eventID,
    }).then(res => {
        return res.data;
    });
}


export async function cancelEvent(auth, eventID) {
    return axios({
        method: 'put',
        url: url + "/events/cancel?bytes32Id=" + eventID,
        headers: { Authorization: `Bearer ${auth}` },
    }).then(res => {
        return res.data;
    });
}

export async function finalizeEvent(auth, eventID) {
    return axios({
        method: 'put',
        url: url + "/events/finalize?bytes32Id=" + eventID,
        headers: { Authorization: `Bearer ${auth}` },
    }).then(res => {
        return res.data;
    });
}

export async function getEventsByCategoryId(categoryId) {

    return axios({
        method: 'get',
        url: url + "/events?categoryId=" + categoryId
        //url: "http://localhost:8000/api/events"
    }).then(res => {

        return res.data;
    });

}

export async function getPropEventsForEvent(eventId) {

    return axios({
        method: 'get',
        url: url + "/events?originalEventId=" + eventId
        //url: "http://localhost:8000/api/events"
    }).then(res => {

        return res.data;
    });

}


export async function getEventsByLeagueId(leagueId) {

    return axios({
        method: 'get',
        url: url + "/events?leagueId=" + leagueId
        //url: "http://localhost:8000/api/events"
    }).then(res => {

        return res.data;
    });

}

export async function getEventsByTeamId(teamId) {

    return axios({
        method: 'get',
        url: url + "/events?teamId=" + teamId
    }).then(res => {
        return res.data;
    });

}

export async function makeEvent(
    authToken,
    bytes32Id,
    teams,
    drawPossible,
    startTime,
    duration,
    makerBond,
    maker,
    cancelled,
    categoryId,
    leagueId,
    teamColors,    
    isPropEvent,
    originalEventId,
    propTitle) {
    return axios.post(url + "/events", {
        bytes32Id,
        teams,
        drawPossible,
        startTime,
        duration,
        makerBond,
        maker,
        cancelled,
        categoryId,
        leagueId,
        teamColors,      
        isPropEvent,
        originalEventId,
        propTitle
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });

}

export async function makePropEvent(
    authToken,
    bytes32Id,
    teams,
    drawPossible,
    startTime,
    duration,
    makerBond,
    maker,
    cancelled,
    categoryId,
    leagueId,
    teamOneColor,
    teamTwoColor,
    isPropEvent,
    originalEventId,
    propTitle) {
    return axios.post(url + "/events/props", {
        bytes32Id,
        teams,
        drawPossible,
        startTime,
        duration,
        makerBond,
        maker,
        cancelled,
        categoryId,
        leagueId,
        finalized : false,      
        isPropEvent,
        originalEventId,
        propTitle
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });

}


// WEBPACK FOOTER //
// ./src/api-calls/events.js